import { render, staticRenderFns } from "./DocOpenApi.vue?vue&type=template&id=c2984b26&scoped=true"
import script from "./DocOpenApi.vue?vue&type=script&lang=js"
export * from "./DocOpenApi.vue?vue&type=script&lang=js"
import style0 from "./DocOpenApi.vue?vue&type=style&index=0&id=c2984b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2984b26",
  null
  
)

export default component.exports